<template>
  <div class="audit-container">
    <div class="audit-container__top-bar">
      <slot name="topBar"></slot>
    </div>
    <div class="audit-container__main">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.audit-container {
  display: flex;
  flex-direction: column;
  gap: 3px;
  height: 100%;
  width: 100%;

  &__top-bar {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__main {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
}
</style>